export { default } from './EmptyMessageCard'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Cards/EmptyMessageCard/index.js